export const path = "/aether/auth/kc/uf";

export const GET_USER_FEDERATION_DATA = `${path}`;

export const POST_CREATE_USER_FEDERATION = `${path}/add`;
export const POST_UPDATE_USER_FEDERATION = `${path}/update`;
export const POST_DELETE_USER_FEDERATION = `${path}/delete`;
export const POST_SYNC_USER_FEDERATION = `${path}/sync`;
